import ClearingAPI from '@shared/api';

export const {
    accounts: { get: getAccounts },
    clearing: { accountApprove, accountVerify, accountReject },
} = ClearingAPI.settings;
